import { cn } from '../lib/utils';
import { HTMLAttributes } from 'react';
import useTranslation from '@backend/hooks/use-translation';

export default function InputError({ message, className = '', ...props }: HTMLAttributes<HTMLParagraphElement> & { message?: string }) {
    const { __ } = useTranslation();

    return message ? (
        <p {...props} className={cn('text-sm text-red-600 dark:text-red-400', className)}>
            { __(message) }
        </p>
    ) : null;
}
